import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { UrlInputModal, BUTTON_SIZE } from 'wix-rich-content-ui-components';
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from 'wix-rich-content-common';
import { VIDEO_TYPE, videoButtonsTypes } from '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class MediaURLInputModal extends Component {
  constructor(props) {
    super(props);
    this.onConfirm = () => {
      var _a, _b;
      const { url } = this.state;
      if (url && ReactPlayer.canPlay(url)) {
        const { componentData, helpers, pubsub, onConfirm } = this.props;
        if (onConfirm) {
          onConfirm(__spreadProps(__spreadValues({}, componentData), { src: url }));
        } else {
          pubsub.update("componentData", { src: url });
        }
        if (helpers && helpers.onVideoSelected) {
          helpers.onVideoSelected(
            url,
            (data) => pubsub.update("componentData", { metadata: __spreadValues({}, data) })
          );
        }
        (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
          pluginId: VIDEO_TYPE,
          buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.embed
        });
        (_b = helpers.closeModal) == null ? void 0 : _b.call(helpers);
      } else {
        this.setState({ submittedInvalidUrl: true });
      }
    };
    this.getRenderData = () => {
      const {
        t,
        isMobile,
        componentData: { type }
      } = this.props;
      const isYouTube = type === videoButtonsTypes.youTube;
      const isSoundCloud = type === videoButtonsTypes.soundCloud;
      const title = isYouTube ? "EmbedURL_Social_YouTube_Title" : isSoundCloud && (isMobile ? "SoundCloudUploadModal_Header_Mobile" : "SoundCloudUploadModal_Header");
      const placeholder = isYouTube ? t("EmbedURL_Social_YouTube_Placeholder") : isSoundCloud && t("SoundCloudUploadModal_Input_Placeholder");
      const dataHook = isYouTube ? "socialEmbedUploadModal" : isSoundCloud ? "soundCloudUploadModal" : "";
      return { title, placeholder, dataHook };
    };
    this.onCloseRequested = () => {
      var _a;
      const { helpers } = this.props;
      (_a = helpers == null ? void 0 : helpers.onPluginsPopOverClick) == null ? void 0 : _a.call(helpers, {
        pluginId: VIDEO_TYPE,
        buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.cancel
      });
      helpers == null ? void 0 : helpers.closeModal();
    };
    const { componentData } = this.props;
    this.state = {
      url: componentData.src || "",
      submittedInvalidUrl: false
    };
  }
  render() {
    const { url, submittedInvalidUrl } = this.state;
    const { t, languageDir } = this.props;
    const { title, placeholder, dataHook } = this.getRenderData();
    return /* @__PURE__ */ React.createElement(
      UrlInputModal,
      {
        onConfirm: this.onConfirm,
        input: url,
        t,
        languageDir,
        title: t(`${title}`),
        submittedInvalidUrl,
        dataHook,
        onInputChange: (url2) => this.setState({ url: url2 }),
        errorMessage: t("SoundCloudUploadModal_Input_InvalidUrl"),
        placeholder,
        onCloseRequested: this.onCloseRequested,
        buttonSize: BUTTON_SIZE.medium
      }
    );
  }
}

export { MediaURLInputModal as default };
//# sourceMappingURL=mediaURLInputModal.js.map
